import React, { useCallback, useEffect, useRef, useState } from 'react'
import orderBy from 'lodash/orderBy'
import { NftMetadata } from 'config/constants/types'
import { NftCollection } from 'state/collectibles/types'
import { throttle } from 'lodash'
import NftCard from 'components/NftCard'
import SimpleNftCard from 'components/NftCard/Simple'
import NftGrid from './NftGrid'

interface NftListProps {
  incomeQuery?: string
  collectionNfts: NftCollection
  nftsList: NftMetadata[]
  tokenIds?: any
  showSwap?: boolean
  selectable?: boolean
  selectedIndexes?: number[]
  isHomeView?: boolean
  handleSelect?: (nftIndex) => void
  reset?: () => void
  SwapCard?: React.FC<any>
}

const NftList: React.FC<NftListProps> = ({
  collectionNfts,
  nftsList,
  tokenIds,
  showSwap = true,
  selectable,
  selectedIndexes = [],
  isHomeView = false,
  handleSelect,
  reset,
  SwapCard,
}) => {
  const [currentNfts, setCurrentNfts] = useState(nftsList)
  const refPrevOffset = useRef(window.pageYOffset)

  // Fetch the next batch of nfts to display
  const fetchNextNfts = useCallback(() => {
    if (currentNfts.length <= nftsList.length) {
      const nextNfts = nftsList.slice(currentNfts.length, currentNfts.length + 8)
      setCurrentNfts(currentNfts.concat(nextNfts))
    }
  }, [currentNfts, nftsList])

  useEffect(() => {
    setCurrentNfts(nftsList.slice(0, 7))
  }, [nftsList])

  useEffect(() => {
    const handleScroll = () => {
      const currentOffset = window.pageYOffset
      if (window.innerHeight + window.pageYOffset + 1200 >= document.body.offsetHeight) {
        fetchNextNfts()
      }
      refPrevOffset.current = currentOffset
    }
    const throttledHandleScroll = throttle(handleScroll, 200)

    window.addEventListener('scroll', throttledHandleScroll)
    return () => {
      window.removeEventListener('scroll', throttledHandleScroll)
    }
  }, [fetchNextNfts])

  return (
    <NftGrid isHomeView={isHomeView}>
      {SwapCard && <SwapCard collection={collectionNfts} selectedIndexes={selectedIndexes} reset={reset} />}
      {orderBy(currentNfts, 'sortOrder').map((nft) => {
        const Card = showSwap ? NftCard : SimpleNftCard

        return (
          <div key={nft.tokenId}>
            <Card
              selectable={selectable}
              collectionAddress={collectionNfts.nftAddress}
              nft={nft}
              tokenIds={tokenIds}
              handleSelect={handleSelect}
              footerLabel={!isHomeView ? 'More' : null}
            />
          </div>
        )
      })}
    </NftGrid>
  )
}

export default NftList
